import { UserDTO, VehicleDTO } from './../services/generated/api.generated.v2';
import { DealerLocationDTO, ImageDTO, ViewVinRegistrationDTO } from 'src/services/generated/api.generated.v1';

export class Location {
  lat?: number;
  lng?: number;

  constructor(lat: number, lng: number) {
    this.lat = lat;
    this.lng = lng;
  }
}

export class DealerLocationVM extends DealerLocationDTO {
  distance?: number | null = null;
  distanceDisplay?: string | null = null;

  constructor(data?: DealerLocationDTO) {
    super();
    if (data) {
      for (const property in data) {
        if (data.hasOwnProperty(property))
          /* eslint-disable @typescript-eslint/no-unsafe-assignment */
          /* eslint-disable @typescript-eslint/no-unsafe-member-access */
          /* eslint-disable @typescript-eslint/no-explicit-any*/

          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
}

export class AdminUser extends UserDTO {
  vins: Array<VehicleDTO> = new Array<VehicleDTO>();
}

export interface DropDownItem {
  label: string;
  value: string;
}

export interface PostResponse {
  id: number;
  slug: string;
  categories: Array<number>;
  yoast_head_json: { og_title: string; article_published_time: string };
  acf: {
    banner_image: { url: string };
    styled_blocks: Array<{ content: string }>;
    related_stories: {
      left: { ID: number; post_name: string; post_title: string };
      center: { ID: number };
      right: { ID: number };
    };
  };
}

export interface FaqResponse {
  yoast_head_json: {
    og_title: string;
  };
  acf: {
    faq_category: Array<{ category_title: string; faq: Array<{ question: string; answer: string }> }>;
    glossary_entry: Array<{ term: string; definition: string }>;
  };
}

export interface PodcastResponse {
  yoast_head_json: {
    og_title: string;
    og_description: string;
    og_image: [{ url: string }];
  };
  acf: {
    episode_url: string;
  };
}

export class VehicleRegistration extends ViewVinRegistrationDTO {
  image?: ImageDTO;

  constructor(data?: ViewVinRegistrationDTO) {
    super();
    if (data) {
      for (const property in data) {
        if (data.hasOwnProperty(property))
          /* eslint-disable @typescript-eslint/no-unsafe-assignment */
          /* eslint-disable @typescript-eslint/no-unsafe-member-access */
          /* eslint-disable @typescript-eslint/no-explicit-any*/

          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
}

export class Post {
  id?: number;
  slug?: string;
  date?: moment.Moment;
  title?: string;
  categories?: Array<number>;
  bannerImageUrl?: string;
  content?: string;
  relatedStoryIds?: Array<number>;
}

export class FAQ {
  title?: string;
  categories?: Array<{ title: string; questions: Array<{ question: string; answerContent: string }> }>;
  glossary?: Array<{ term: string; definition: string }>;
}

export class Podcast {
  title?: string;
  imageUrl?: string;
  linkUrl?: string;
  description?: string;
}

export class GoogleAnalyticsTags
{
  screenPath?: string;
  screenName?: string;
  event?: string;
  appEventCategory?: string;
  appEventAction?: string;
  appEventLabel?: string;
}

